module.exports = __webpack_public_path__ + "img/repair.d44ca74b.png";